import { render } from "./AddCertificate.vue?vue&type=template&id=2509b8e2&scoped=true"
import script from "./AddCertificate.vue?vue&type=script&lang=js"
export * from "./AddCertificate.vue?vue&type=script&lang=js"

import "./AddCertificate.vue?vue&type=style&index=0&id=2509b8e2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2509b8e2"]])

export default __exports__